import { AppConfig } from '@infodata-group/inf-commons';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TicketConfig extends AppConfig {
  public hasAccess = false;
  public ticketWiAppId: string;
  public ticketAppId: string;

  override init(result: any) {
    super.init(result);
    if (
      result['ticketAppId'] &&
      result['ticketWiAppId'] &&
      result['ticketAppId'] !== '' &&
      result['ticketWiAppId'] !== ''
    ) {
      this.hasAccess = true;
      this.ticketWiAppId = result['ticketWiAppId'];
      this.ticketAppId = result['ticketAppId'];
    }
  }
}
